export default {
  cities: [],
  city: {},
  blockCities: []
}



// WEBPACK FOOTER //
// ./src/components/city/store/state.js